import React, { useState } from 'react';
import "../../../styles/buscador/buscador.css"
import ResultadosBusquedas from './Resultados_busquedas';
import "../../../styles/redes.css"

const Buscador = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleSearch = (event) => {
    event.preventDefault();
    if (!searchQuery.trim()) {
      alert('No buscaste nada');
    } else {
      setModalIsOpen(true);
    }
  };

  return (
    <div className="topnav">
      <div className="search-container">
        <form onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Escriba aqui su busqueda..."
            name="search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit">Buscar !</button>
        </form>
      </div>
      {modalIsOpen && <ResultadosBusquedas searchQuery={searchQuery} closeModal={() => setModalIsOpen(false)} />}
    </div>
  );
};

export default Buscador;
